import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "blur"
}
const _hoisted_2 = { class: "title2 title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "safari-close",
  class: "text"
}, "X", -1)
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Background = _resolveComponent("Background")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Settings = _resolveComponent("Settings")!

  return (_openBlock(), _createElementBlock("div", {
    id: "content",
    class: _normalizeClass({ light: !_ctx.darkMode })
  }, [
    _createVNode(_component_Background),
    _createVNode(_component_Menu),
    _createVNode(_component_router_view),
    _createVNode(_component_Settings),
    (_ctx.showSafariPopUp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.showSafariPopUp)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: "safari-info",
          class: _normalizeClass({ light: !_ctx.darkMode }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSafariPopUp = false))
        }, [
          _createElementVNode("div", {
            id: "safari-head",
            class: _normalizeClass({ light: !_ctx.darkMode })
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("safari.title")), 1),
            _hoisted_3
          ], 2),
          _createElementVNode("div", {
            class: "text",
            innerHTML: _ctx.$t('safari.text')
          }, null, 8, _hoisted_4)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}